import * as React from "react";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { useLocation } from "react-router-dom";

import SideMenuMobile from "./SideMenuMobile";

const titlesByPath = [
  { path: "/painel", title: "Dashboard" },
  { path: "/canais", title: "Canais" },
  { path: "/listagens", title: "Listagens" },
  { path: "/modelos", title: "Modelos" },
  { path: "/campanhas", title: "Campanhas" },
  { path: "/integrações", title: "Integrações" },
];

function getPageTitle(pathname) {
  const match = titlesByPath.find((item) =>
    decodeURIComponent(pathname).startsWith(item.path)
  );
  return match?.title || "123zap";
}

export default function AppNavbar() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: "flex", md: "none" },
        boxShadow: 0,
        bgcolor: "background.paper",
        backgroundImage: "none",
        borderBottom: "1px solid",
        borderColor: "divider",
        top: "var(--template-frame-height, 0px)",
      }}
    >
      <Toolbar sx={{ minHeight: 72, px: 2 }}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            flexGrow: 1,
            width: "100%",
            gap: 1,
          }}
        >
          <Typography
            variant="h6"
            component="h1"
            sx={{ color: "text.primary", mr: "auto", fontWeight: 600 }}
          >
            {getPageTitle(location.pathname)}
          </Typography>

          <IconButton aria-label="abrir menu" onClick={toggleDrawer(true)}>
            <MenuRoundedIcon />
          </IconButton>
        </Stack>
      </Toolbar>

      <SideMenuMobile open={open} toggleDrawer={toggleDrawer} />
    </AppBar>
  );
}
